export const bundleToHrts = new Map<number, number[]>([
  // previous sorin org (orgId: 1)
  [12, [179]], // supreme
  [13, [179, 173]], // ultimate
  [14, [179, 173, 154, 392, 166]], // legacy
  // new sorin org (orgId: 49)
  [8035, [7734]], // supreme
  [8037, [7734, 7749]], // ultimate
  [8036, [7734, 7749, 7736, 7737, 8040]], // legacy
  [307, [306, 651, 651, 651, 651, 651]], // ketamine IV mind x6
  [305, [304, 650, 650, 650, 650, 650]], // ketamine IV pain x6
  [434, [433, 654, 654, 654, 654, 654]], // ketamine IV x6
  [413, [412, 652, 652, 652, 652, 652]], // ketamine IV x6
  [416, [412, 652, 652, 652, 652, 652, 653, 653, 653, 653]], // ketamine therapy support package
  [417, [412, 652, 652, 652, 652, 652, 670, 670, 670, 670, 670, 670, 670]], // ketamine therapy advanced support package
  [371, [656, 2685, 2685, 2685, 2685]], // HBOT x5
  [273, [2689, 2686, 2686, 2686, 2686, 2686, 2686, 2686, 2686, 2686]], // HBOT x10
  [
    274,
    [
      659, 2687, 2687, 2687, 2687, 2687, 2687, 2687, 2687, 2687, 2687, 2687,
      2687, 2687, 2687, 2687, 2687, 2687, 2687, 2687,
    ],
  ], // HBOT x20
  [
    360,
    [
      661, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688,
      2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688,
      2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688, 2688,
      2688, 2688, 2688, 2688,
    ],
  ], // HBOT x40
  [255, [655, 2693, 2693]], // EBOO bundle
  [378, [663, 2690, 2690]], // plasmapheresis x3
  [379, [664, 2691, 2691, 2691, 2691, 2691]], // plasmapheresis x6
  [
    380,
    [666, 2692, 2692, 2692, 2692, 2692, 2692, 2692, 2692, 2692, 2692, 2692],
  ], // plasmapheresis x12
  [426, [671, 672]], // SGB new patient
  [705, [373, 708]], // comprehensive diagnostics package with free generation labs
  [706, [242, 707]], // dexa scan + free 3d pas
  [1741, [2611, 2615, 2615, 2615, 2615, 2615, 2616]], // post op surgery basic
  [
    2058,
    [
      2612, 2615, 2615, 2615, 2615, 2615, 2615, 2615, 2615, 2615, 2615, 2616,
      2616,
    ],
  ], // post op surgery advanced
  [3176, [3177, 2693]], // EBOO bundle for Parsley health
  [3178, [3179, 2690]], // Plasmapheresis bundle for Parsley health
  [3181, [1793, 3180]], // Peptide Consult NP + Free Dexa Scan Bundle
  [3182, [1828, 3180]], // Peptide Consult NP Virtual + Free Dexa Scan Bundle

  [3859, [3862, 3863, 3864, 297]], // 1 Package Plasma: 1 x suPAR $0, 1 x EH Extended CORE Panel $0, 1 x Total Tax Bundle $0, 1 x New Patient Plasma $10,000
  [3860, [3862, 3862, 3863, 3863, 3864, 3864, 3865, 2690, 2690]], // 3 Package Plasma: 2 x suPAR $0, 2 x EH Extended CORE Panel $0, 2 x Total Tax Bundle $0, 1 x New Patient Plasma $27,000, 2 x Follow Up Plasma $0
  [
    3861,
    [3862, 3862, 3863, 3863, 3864, 3864, 3866, 2690, 2690, 2690, 2690, 2690],
  ], // 6 Package Plasma: 2 x suPAR $0, 2 x EH Extended CORE Panel $0, 2 x Total Tax Bundle $0, 1 x New Patient Plasma $45,000, 5 x Follow Up Plasma $0
  [4881, [4470, 4604, 4879, 4540]], // Core Cardiac Assessment (Consult + Electrocardiogram (ECG) + Echocardiogram + Cardionow Heart Scan)
  [4882, [4470, 4604, 4880, 4540, 4606, 4607, 4608]], // Comprehensive Cardiovascular Assessment (Consult + Electrocardiogram (ECG) + Echocardiogram + Cardionow Heart Scan + Carotid Ultrasound + Abdominal Aorta Ultrasound + Ankle-Brachial Index (ABI))
  [
    207,
    [
      206, 206, 206, 206, 206, 206, 206, 206, 206, 206, 206, 206, 206, 206, 206,
      206, 206, 206, 206, 206,
    ],
  ], // 20 dummy heart scans to test 500 char metadata integration test in hex-frontend under testerscript org.
  [10162, [372, 372]], // 2 Baseline diagnostics packages -> tied with a BOGO promo code
  [10163, [241, 241]], // 2 DEXA Scans -> tied with a BOGO promo code
]);
